// src/pages/ResetPasswordPage.js
import React, { useState } from 'react';
import HeaderBar from '../components/HeaderBar';
import Footer from '../components/Footer';
import { apiGet, apiPost } from '../lib/apiClient';
import { useNavigate } from 'react-router-dom';

export default function ResetPasswordPage() {
  const [username, setUsername] = useState('');
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const fetchQuestion = async () => {
    setMessage('');
    setError('');
    setQuestion('');
    try {
      const res = await apiGet(`/api/auth/challenge?username=${encodeURIComponent(username)}`);
      setQuestion(res?.question || '');
    } catch (err) {
      setError(err?.msg || err?.message || 'Could not load challenge question.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await apiPost('/api/auth/reset-password', {
        username,
        answer,
        newPassword,
      });
      setMessage('Password updated. Redirecting to sign in…');
      setAnswer('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => navigate('/signin', { replace: true }), 800);
    } catch (err) {
      setError(err?.msg || err?.message || 'Password reset failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <HeaderBar />
      <main className="auth-page">
        <div className="card" style={{ maxWidth: 480, margin: '32px auto', padding: 24 }}>
          <h2 style={{ marginTop: 0, marginBottom: 12 }}>Reset password</h2>
          <p style={{ marginTop: 0, color: '#4b5563' }}>
            Provide your username to view your challenge question. Answers are case-insensitive.
          </p>

          <div style={{ display: 'grid', gap: 12, marginBottom: 16 }}>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Username</span>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
              />
            </label>
            <button className="btn" type="button" onClick={fetchQuestion} disabled={!username}>
              Load challenge question
            </button>
          </div>

          {question && (
            <div className="card" style={{ padding: 16, background: '#f9fafb', border: '1px solid #e5e7eb', marginBottom: 16 }}>
              <strong>Challenge question:</strong>
              <div style={{ marginTop: 6 }}>{question}</div>
              <div style={{ marginTop: 6, fontSize: 12, color: '#4b5563' }}>
                Answers are case-insensitive.
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 12 }}>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Challenge answer</span>
              <input
                type="text"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                required
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>New password</span>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Confirm new password</span>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </label>
            <button className="btn primary-btn" type="submit" disabled={loading || !question}>
              {loading ? 'Updating…' : 'Update password'}
            </button>
          </form>

          {message && <div style={{ marginTop: 12, color: '#065f46' }}>{message}</div>}
          {error && <div style={{ marginTop: 12, color: '#b91c1c' }}>{error}</div>}
        </div>
      </main>
      <Footer />
    </div>
  );
}
